import './FilterParts.scss';
interface InfoTipProps {
    /** La frase corta que explica el término. */
    text: string;
}

/**
 * Ícono ⓘ con una frase en un tooltip (patrón `nv-tip`, que muestra el `NvTooltips` de la pantalla). Se alcanza con
 * el teclado y el texto queda disponible para el lector de pantalla.
 */
export default function InfoTip({ text }: InfoTipProps) {
    return (
        <span className="nv-tip nv-info" tabIndex={0} data-pr-tooltip={text}>
            <i className="pi pi-info-circle" aria-hidden="true" />
            <span className="nv-sr-only">{text}</span>
        </span>
    );
}
